import type { TFunction } from 'i18next';
import { z } from 'zod';
import { jsonSchemaType } from '@/shared/schema';

export const createContractSchema = (
  t: TFunction<'compat'>,
  metadataSchema: z.ZodObject<z.ZodRawShape>,
  dynamicMetadataSchema: z.ZodObject<z.ZodRawShape>
) =>
  z.object({
    contractNumber: z.string().optional(),
    title: z.string().min(1, t('validation.required')),
    customer: z.string().min(1, t('validation.required')),
    objects: z.array(z.string()).optional(),
    startDate: z.string().min(1, t('validation.required')),
    endDate: z.string().min(1, t('validation.required')),
    description: z.string().optional(),
    status: z.enum(['open', 'closed']).optional(),
    metadata: metadataSchema,
    dynamicMetadataSchema: jsonSchemaType.optional(),
    dynamicMetadataValues: dynamicMetadataSchema,
  });
